<div class="row">
    <div class="col-6">
        <h1>Pagos</h1>
    </div>
    <div class="col-6 ">
      <div style="text-align: right">
        <input type="month" id="start" name="start"
       min="2022-08" [(ngModel)]="date" (change)="getInstallmentes()">
      </div>
    </div>
</div>

<!--app-users-->
<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                    <thead>
                        <tr>
                        <th scope="col">Contracto</th>
                        <th scope="col">Nombre</th>
                        <th scope="col"># pago</th>
                        <th scope="col">Cantidad</th>
                        <th scope="col">Fecha de pago</th>
                        <th scope="col">Referencia</th>
                        <th scope="col">Status</th>
                        <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let installment of installments">
                        <td><a target="_blank" routerLink="/contract-details/{{installment.idContract}}" >{{ installment.idContract }}</a></td>
                        <td>{{ installment.instName }}</td>
                        <td>{{ installment.installmentNumber }}</td>
                        <td>{{ installment.installmentAmount | currency }}</td>
                        <td>{{ installment.installmentDate | date:'short'  }}</td>
                        <td>{{ installment.reference }}</td>
                        <td *ngIf="installment.paid"><span style="color: green;">Pagado</span></td>
                        <td *ngIf="!installment.paid"><span style="color: red;">Pendiente</span></td>
                        <td><button type="button" (click)="markPaid(installment)" class="btn btn-secondary" data-toggle="modal" data-target="#editPayModal">Editar</button></td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-edit-payment [installmentData]="installmentEdit"></app-edit-payment>

<div *ngIf="loading" class="d-flex justify-content-center loading-screen">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
